// extracted by mini-css-extract-plugin
module.exports = {"appControl":"appControl_appControl__HWG6n"};